import React from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '~/components/elements/Typography'

import { useMainQueryStrategyMemo } from '../hooks/useMainQuery'

export const LastSavedDisplay = () => {
  const strategyMemo = useMainQueryStrategyMemo()
  const { t } = useTranslation()

  return (
    <Typography variant="normal">
      {t('last_saved')}
      {new Date(strategyMemo.updatedAt).toLocaleString()}
    </Typography>
  )
}
